import React from 'react';
import './styles.scss';

import logo from './img/logo.svg';

const Logo = () => (
  <div className="logo-body">
    <img className="logoimg" src={logo} alt="Logo" />
    <br />
    <p className="login-caption" >Forgot your password?</p>
    <p className="login-prompt">Enter your email address below and we`ll get you back on track.</p>
  </div>
);
export default Logo;



// WEBPACK FOOTER //
// ./src/pages/LoginAdmin/commponents/LogoForgotPass/index.js